module.exports = __webpack_public_path__ + "img/index_lableIcon1.19cbbdb4.png";